import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, from } from 'rxjs';
import { API } from 'aws-amplify';

export const REPORTS_API_NAME: string = 'reports';
export const REPORTS_API_ENDPOINT: string = environment.API_BASE_PATH + '/report';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  export(report_email: string, report_type: string, filters?: any): Observable<any> {
    const api_name: string = REPORTS_API_NAME;
    let path = '';
    switch (report_type) {
      case 'unpaid':
        path = '/export-unpaid';
        break;
      case 'store':
        path = '/export-store';
        break;
      case 'seller':
        path = '/export-seller';
        break;
      case 'company':
        path = '/export-company';
        break;
      case 'order':
        path = '/export-order';
        break;
      case 'buyer':
        path = '/export-buyer';
        break;
      case 'vop_request':
        path = '/export-vop-report';
        break;
    }

    const init = {
      response: true,
      body: {
        report_email,
        ...filters,
      },
    };

    return from(API.post(api_name, path, init));
  }
}
